import formApplicant from './components/formApplicant'
import respondentList from './components/respondentList'
import dialogPreview from '@/components/dialogPreview/dialogPreview'
import Api from '@api/api'
import { Dialog, ImagePreview } from 'vant'
import { uuid, isEmojiCharacter } from '@/utils'
import mobileSignDialog from '@/components/mobileSignDialog/mobileSignDialog'
// 本次进表单后最多可新上传的材料份数（历史材料不占额度）
const MAX_UPLOAD_COUNT = 10
const moduleCodeSwitch = () => {
  switch (localStorage.getItem('oprate')) {
    case 'apply':
      return '1'
      break
    case 'search':
      return '2'
      break
    case 'revokeApply':
      return '3'
      break
  }
}
export default {
  components: { formApplicant, respondentList, dialogPreview, mobileSignDialog },
  data () {
    return {
      loading1: {},
      loading2: {},
      mobileDepart: [],
      dateVisable: false,
      istraffic: null,

      caseStatusText: '',
      fullscreenLoading: false, // loading加载
      historyList: [],
      showPicker: false,
      applicantCategory: localStorage.getItem('applicantCategory') || '1', // 当前申请人类型
      // 步骤条
      stepList: [
        {
          name: '申请人'
        },
        {
          name: '被申请人'
        },
        {
          name: '行政复议请求'
        },
        {
          name: '事实理由'
        },
        {
          name: '材料上传'
        }
      ],
      defaultDate: new Date(),
      formatter (type, value) {
        if (type === 'year') {
          return `${value}年`
        }
        if (type === 'month') {
          return `${value}月`
        }

        if (type === 'day') {
          return `${value}日`
        }
        return value
      },
      // 申请人信息
      applicantInfoList: [],
      applicantInfo: {
        applicantCategory: '1', // 1 个人 2法人
        applicantName: '',
        gender: '', // 0 女 1 男
        country: '1000001',
        countryName: '中国',
        identificationType: '',
        identificationCard: '',
        identificationFile: '', // 证件材料路径
        birthday: '', // 出生日期
        phone: '',
        telephone: '', // 座机
        addr: '',
        postcode: '',
        deliveryAddr: '', // 送达地址
        deliveryPostcode: '', // 送达地址邮编
        fileListJpg: [],
        fileListJpg2: [],
        deliveryArea: ['上海市', '市辖区', '黄浦区'],
        isidType: false, // 证件类型不能更改
        isbornDate: false // 证件类型为身份证时 出生日期不可修改
      },
      legalpersonInfo: {
        applicantCategory: '2',
        applicantName: '',
        legalRepresentative: '',
        legalRepresentativeDuty: '',
        country: '',
        contactName: '',
        identificationType: '',
        socialUnifiedCreditCode: '',
        identificationCard: '',
        fileListJpg2: [],
        identificationFile: '',
        phone: '',
        telephone: '',
        addr: '',
        postcode: '',
        deliveryArea: ['上海市', '市辖区', '黄浦区'],
        deliveryPostcode: '',
        fileListJpgfR: [],
        fileListJpg: []
      },
      respondentInfos: {},
      // 被申请人信息
      // 被申请人列表
      respondentList: [{
        id: '',
        name: ''
      }],
      respondentIndex: 0, // 点击第几个被申请人
      respondentDialog: false, // 点击第几个弹窗
      respondentInfo: [],
      optionDepartId: [],
      // 被申请人名称
      optionRespondentName: [],
      // 行政复议请求
      applyInfo: {
        actCategory: '1', // 1不服行政不作为 2不服具体行政行为
        applyType: '请求责令被申请人履行  事项的法定职责。',
        actName: '',
        actDocumentNo: '',
        actDecisionDate: '',
        specificActType: '1' // 1请求撤销具体行政行为 2请求确认具体行政行为违法
      },
      // 事实和理由
      factAndReason: '',
      // 证据材料
      fileList1: [],
      fileoneLoad: false,
      fileList2: [],
      rest1: 0,
      rest2: 0,
      respondentInfoRules: {
        departId: [
          { required: true, message: '请选择复议机关', trigger: 'change' }
        ],
        respondentName: [
          { required: true, message: '请选择被申请人', trigger: 'change' }
        ]
      },
      // 必填信息
      inquireInfo: {
        caseOrderNo: '',
        reconsiderationAgency: '',
        inquirePhone: ''
      },
      // 申请编号
      number: '',
      uploadFileUrl: '',
      password: '',
      isDetail: false,
      caseOrderNo: '',
      evidenceIdList: [],
      modifyStatus: 0, // 补正中状态 0-没有补正 1-正在补正中 2-补正中完成
      caseStatus: '', // 案件状态 1-已提交 2-补正中 3-已受理 4-已办结
      showResultDoc: false,
      allDepartList: [], // 全部机构数据
      fileReviewDialog: false,
      writList: [],
      imgList: [],
      agency: {
        id: '',
        name: ''
      },
      name: '',
      opera: 0, //当前操作 0-新增 1-补正 2-补充 3-查看 4-撤回
      isAgreeMediate: null, //是否同意调解 0-否 1-是
      detailInfo: {},
      isSign: false // 是否签名完成了
    }
  },
  created () {
    // 获取复议机关
    Api.getAgency().then((res) => {
      const arr = []
      this.optionDepartId = res.data.data
      res.data.data.forEach(item => {
        const text = item.name.startsWith('上海市') ? item.name : '上海市' + item.name
        arr.push({
          id: item.id,
          text,
          shortName: item.shortName
        })
      })
      this.mobileDepart = arr
    })
    // 获取复议机关对应数据
    Api.getEntrustingAllDepartList().then(({ data }) => {
      data.data.map(item => {
        item.text = item.name
        item.departId = item.id
      })
      this.allDepartList = data.data
    })
    // 如果有编号 补正进入修改申请，否则新建申请
    this.number = this.$route.query.number ? this.$route.query.number : ''
    this.opera = this.$route.query.opera ? this.$route.query.opera : 0
    // 补充进入页面后提醒
    if (this.opera == 2) {
      Dialog.alert({
        title: '提示',
        message: '线上补件仅一次，请确认完整',
        confirmButtonText: '确定',
        customClass: 'supplementTipBox'
      })
    }
    // 详情
    if (this.number) {
      this.caseOrderNo = this.number || uuid()
      this.isDetail = true
      Api.getAgency().then((res) => {
        const arr = []
        this.optionDepartId = res.data.data
        res.data.data.forEach(item => {
          const text = item.name.startsWith('上海市') ? item.name : '上海市' + item.name
          arr.push({
            id: item.id,
            text,
            shortName: item.shortName
          })
        })
        this.mobileDepart = arr
        this.$nextTick(() => {
          this.getCaseInfoDetail()
        })
      })
    } else {
      // 新建
      this.inquireInfo.caseOrderNo = this.$route.query.caseOrderNo || uuid()
      this.caseOrderNo = this.inquireInfo.caseOrderNo
      this.isDetail = false
    }
    // 首页进来先添加一个申请人信息将上个页面带进来
    this.addApplicantInfo(this.applicantCategory)
  },
  computed: {
    // 本次进表单后已新上传的份数（不含历史材料）
    uploadedCount1 () {
      return this.fileList1.filter(item => !item.isHistory).length
    },
    // el-upload 的 limit 是跟完整 fileList（含历史材料）比的，
    // 而补充材料阶段 fileList1 里已经塞满了历史材料，
    // 所以额度要把历史份数加回去，才能做到"历史不占额度、本次最多传 10 份"
    uploadLimit1 () {
      const historyCount = this.fileList1.filter(item => item.isHistory).length
      return historyCount + MAX_UPLOAD_COUNT
    },
    // 根据被申请人过滤复议机关下拉列表（PC端 el-select 用）
    filteredOptionDepartId () {
      const respondentName = (this.respondentList[0] && this.respondentList[0].name) || ''
      const districtMatch = respondentName.match(/([^市\s]+区)司法局/)
      if (districtMatch) {
        return this.optionDepartId.filter(item => {
          if (item.name.includes('上海市司法局')) return true
          if (item.name.includes(districtMatch[1])) return true
          return false
        })
      }
      // 非司法局场景，过滤掉"上海市司法局"
      return this.optionDepartId.filter(item => !item.name.includes('上海市司法局'))
    },
    // 根据被申请人过滤复议机关列表（移动端 van-picker 用）
    filteredMobileDepart () {
      const respondentName = (this.respondentList[0] && this.respondentList[0].name) || ''
      const districtMatch = respondentName.match(/([^市\s]+区)司法局/)
      if (districtMatch) {
        return this.mobileDepart.filter(item => {
          if (item.text.includes('上海市司法局')) return true
          if (item.text.includes(districtMatch[1])) return true
          return false
        })
      }
      // 非司法局场景，过滤掉"上海市司法局"
      return this.mobileDepart.filter(item => !item.text.includes('上海市司法局'))
    },
    // 复议机关下拉框是否可选：只有被申请人是"XX区司法局"时才可选
    isAgencySelectable () {
      const respondentName = (this.respondentList[0] && this.respondentList[0].name) || ''
      return /[^市\s]+区司法局/.test(respondentName)
    }
  },
  watch: {
    // 是否交通处罚是否展示
    istraffic: function () {
      this.agency = {}
      this.respondentList = [{
        id: '',
        name: ''
      }]
    },
    'applyInfo.specificActType': function () {
      this.actDocumentNoBlur()
    },
    'applyInfo.actCategory': function (val) {
      if (val == 2) {
        this.actDocumentNoBlur()
      } else {
        this.applyInfo.applyType = '请求责令被申请人履行  事项的法定职责。'
      }
    },
    writList: function (newVal) {
      if (newVal) {
        newVal.map(item => {
          item.fileBaseUri = 'data:image/png;base64,' + item.fileBaseUri
        })
        this.imgList = newVal
      }
    },
  },
  mounted () {
    // 获取复议机关
    this.inquireInfo.inquirePhone = this.$cookie.get('LoginPhone')
    this.name = this.$route.query.name
    // if (
    //   typeof this.inquireInfo.inquirePhone === 'undefined'
    // ) {
    //   this.$router.push('/codeSearch')
    // }
  },
  methods: {
    signatureSubmit (event) {
      console.log(event);
      this.fileReviewDialog = true;
      this.$nextTick(() => {
        this.writList = event.data.data.showImgPathList
      })
      this.isSign = true; // 已签名
    },
    preview (URL){
      ImagePreview({
        images: [URL],
        closeable: true,
      })
    },
    dateCancel () {
      this.dateVisable = false
    },
    dateConfirm (detail) {
      console.log(detail)
      const actDecisionDate = this.$moment(detail).format('yyyy-MM-DD')
      this.defaultDate = detail
      this.applyInfo.actDecisionDate = actDecisionDate
      this.dateVisable = false
      this.actDocumentNoBlur()
    },
    dateClick () {
      this.dateVisable = true
    },
    // 复议机关下拉选择变化时同步更新 name 和 shortName
    onAgencyChange (id) {
      const item = this.filteredOptionDepartId.find(item => item.id === id)
      if (item) {
        this.agency = {
          id: item.id,
          name: item.name,
          shortName: item.shortName
        }
      }
    },
    onConfirm (val) {
      this.agency = {
        name: val.text,
        id: val.id,
        shortName: val.shortName
      }
      console.log(this.agency.id)
      this.showPicker = false
    },
    // 打开复议机关弹窗
    reconsiderationAgencyClick () {
      if (this.opera == '1') {
        this.$toast({
          message: '补正阶段复议机关不可改变',
          duration: 4000
        })
        return
      }
      // 只有被申请人是"XX区司法局"时才允许选择复议机关
      if (!this.isAgencySelectable) {
        return
      }
      this.showPicker = true
    },
    handlePreview (item) {
      console.log(item, window.g.fileUrl)
      const p = {
        evidencePath: item.originPath || item.showPath.includes('https://landing.iflysec.com:443') ? item.showPath.replace('https://landing.iflysec.com:443', 'http://172.31.243.74:88') : item.showPath,
        evidenceType: item.evidenceType,
        evidenceName: item.evidenceName
      }
      console.log(p)
      // ImagePreview({
      //   images: [p.evidencePath],
      //   closeable: true,
      // });
      this.$refs.dialogPreview.open(p)
    },
    openCh (data) {
      console.log(data)
      this.fileReviewDialog = true
      console.log(data.data.showImgPathList)
      this.writList = data.data.showImgPathList
    },
    clearFh(val, field) {
      let value = val.replace(new RegExp("[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]", "gm"), "")
      //空格
      let ageValue=value.replace(/\s+/g, '')
      this[field] = ageValue
    },
    actDocumentNoBlur(){
      if (this.applyInfo.specificActType == 1 && this.applyInfo.actCategory == 2)
        this.applyInfo.applyType = `请求撤销被申请人于${this.applyInfo.actDecisionDate ? this.$moment(this.applyInfo.actDecisionDate).format('yyyy年MM月DD日') : ''}作出的${this.applyInfo.actName? `《${this.applyInfo.actName}》`: ''}${this.applyInfo.actDocumentNo? `（${this.applyInfo.actDocumentNo}）`: ''}的行政行为`
      if (this.applyInfo.specificActType == 2 && this.applyInfo.actCategory == 2)
        this.applyInfo.applyType = `请求确认被申请人于${this.applyInfo.actDecisionDate ? this.$moment(this.applyInfo.actDecisionDate).format('yyyy年MM月DD日') : ''}作出的${this.applyInfo.actName? `《${this.applyInfo.actName}》`: ''}${this.applyInfo.actDocumentNo? `（${this.applyInfo.actDocumentNo}）`: ''}的行政行为违法`
    },
    // 输入被申请人确定的时候
    respondentInputConfirm(event) {
      console.log(event)
      const {
        respondentList,
        respondentIndex
      } = this
      if(this.istraffic == '1'){
        console.log(123);
        //根据 0918 需求如果在交通处罚情况为是的时候 则不让他输入
        return this.$toast('是交通处罚请选择下方被申请人');
      }
      respondentList[respondentIndex].name = event
      this.computedAgencyName()
      this.checked()
      if (this.opera != 1) {
        this.agency = this.mateAgency(event)
      }

      this.respondentList = respondentList
      this.respondentDialog = false
    },
    // 根据输入的内容匹配对应的复议机关
    mateAgency (val) {
      const { optionDepartId } = this
      const cs = optionDepartId.map(item => item.name.match(/(\S*)区/) ? item.name.match(/(\S*)区/)[1] : '上海')
      const mateVal = cs.find(item => val.includes(item))
      const obj = optionDepartId.find(item => item.name.includes(mateVal))
      if (obj && obj.id) {
        return {
          name: obj.name,
          id: obj.id,
          shortName: obj.shortName
        }
      } else {
        return {}
      }
    },
    // 选择复议机关
    selectRespondent (item) {
      this.respondentList[this.respondentIndex].id = item.id
      this.respondentList[this.respondentIndex].departId = item.id
      this.respondentList[this.respondentIndex].name = item.name
      // 只有新增模式下 自动带出复议机关
      if (this.opera == '0') {
        this.agency = item.agency ? item.agency : {}
        if (item.name && item.name.includes('上海市司法局')) {
          const shanghaiGov = this.optionDepartId.find(dept =>
            dept.name && dept.name.includes('上海市人民政府')
          )
          if (shanghaiGov) {
            this.agency = {
              id: shanghaiGov.id,
              name: shanghaiGov.name,
              shortName: shanghaiGov.shortName
            }
          }
        } else if (this.agency.name) {
          this.agency.name = this.agency.name.startsWith('上海市') ? this.agency.name : '上海市' + this.agency.name
        }
        // 非区司法局的被申请人，复议机关不能是"上海市司法局"，需要重新匹配正确的复议机关
        const isDistrictSifaju = /[^市\s]+区司法局/.test(item.name)
        if (!isDistrictSifaju && this.agency.name && this.agency.name.includes('司法局')) {
          // 使用 mateAgency 重新匹配正确的复议机关（区级对应区人民政府，市级对应市人民政府）
          this.agency = this.mateAgency(item.name)
        }
        // 被申请人本身是"某某区人民政府"时，复议机关一定是"上海市人民政府"
        // 必须锚定名称结尾：街道办等下级机关全称也含"区人民政府"（如"虹口区人民政府嘉兴路街道办事处"），不能抬到市级
        if (item.name && /区人民政府$/.test(item.name)) {
          const shanghaiGov = this.optionDepartId.find(dept =>
            dept.name && dept.name.includes('上海市人民政府')
          )
          if (shanghaiGov) {
            this.agency = {
              id: shanghaiGov.id,
              name: shanghaiGov.name,
              shortName: shanghaiGov.shortName
            }
          }
        }
      }
      this.respondentDialog = false
      this.computedAgencyName()
      this.checked()
    },

    // 匹配被申请人信息
    computedAgencyName () {
      const {
        respondentList,
        allDepartList
      } = this
      respondentList.forEach(item => {
        if (item.departId) {
          const depart = allDepartList.find(depart => depart.id == item.departId)
          if (depart && depart.agency) {
            item.agencyId = depart.agency.id
            item.agencyName = depart.agency.name
          }
        }
      })

      const arr = []
      respondentList.forEach(item => {
        if (item.agencyName) {
          arr.push(item.agencyName)
        }
      })

      const respondentInfoName = respondentList[0].name
      this.respondentInfoName = respondentInfoName
      this.respondentList = respondentList
    },

    // 校验被申请人
    checked () {
      const {
        respondentList,
        agency,
        opera
      } = this
      // 非编辑模式 不再做被申请人和复议机关关系判断的强控
      if (opera != '0') {
        return false
      }

      const countObj = {}
      let checkdFlag = 0

      respondentList.forEach(item => {
        if (countObj[item.departId]) {
          countObj[item.departId] += 1
        } else {
          if (item.departId) {
            countObj[item.departId] = 1
          }
        }

        if (!item.name) {
          checkdFlag = 1
        }
      })

      if (!agency.id) {
        checkdFlag = 3
      }

      for (const id in countObj) {
        if (countObj[id] > 1) {
          this.$toast({
            message: '不能重复选取同一被申请人',
            duration: 4000
          })
          checkdFlag = 4
          break
        }
      }

      if (checkdFlag == 1) {
        this.$toast({
          message: '被申请人有未填写的',
          duration: 4000
        })
      }

      if (checkdFlag == 3) {
        this.$toast({
          message: '被申请人可能不正确',
          duration: 3000
        })
      }

      if (checkdFlag == '0') {
        this.$toast({
          message: '校验通过',
          duration: 4000
        })
      }
      return checkdFlag != '0'
    },
    // 打开被申请人信息
    respondentClick (index) {
      if (this.opera == 0) { // 申请状态
        if (this.istraffic != 1 && this.istraffic != 0) { // 是否交通处罚已选择
          return this.$toast('请先选择是否交通处罚')
        }
      }
      this.respondentIndex = index
      this.respondentDialog = this.opera == 0 || this.opera == 1
      this.$nextTick(() => {
        this.$refs.respondentList.init()
      })
    },
    // 删除被申请人
    removeRespondent (index) {
      const respondentList = this.respondentList
      respondentList.splice(index, 1)
      // this.checked() // 校验被申请人
    },
    // 添加被申请人
    addRespondent () {
      const respondentList = this.respondentList
      respondentList.push({
        id: '',
        name: ''
      })
    },
    // 复议机关
    ChangeReconsiderationAgency (v) {
      console.log('复议机关', v)
      this.respondentInfo = []
      this.getEntrustingDepartList(v.id)
    },
    // 获取被申请人名称
    getEntrustingDepartList (p) {
      Api.getEntrustingDepartList(p).then((res) => {
        this.optionRespondentName = res.data.data
      })
    },
    // 详情
    getCaseInfoDetail () {
      const p = {
        moduleCode: moduleCodeSwitch(),
        caseOrderNo: this.caseOrderNo // 查询编码
      }

      Api.detail(p).then((res) => {
        if (res.data.code === '0') {
          const data = res.data.data
          const evidence = data.evidenceList || []
          if (evidence && evidence.length) {
            evidence.map(item => {
              item.url = item.evidenceAllPath
              item.name = item.evidenceName
              item.isHistory = true
            })
          }

          const specFileList = []
          const otherFileList = []
          const historyList = []
          for (let i = 0; i < evidence.length; i++) {
            // type=9的附件为 行政复议申请书
            if (evidence[i].kindType === 9 || evidence[i].kindType === 7) {
              const applyBook = evidence[i]
              this.applyBook = applyBook
              historyList.push(applyBook)
              continue
            } else {
              specFileList.push(evidence[i])
            }
          }

          const respondentInfoData = data.respondentInfo // 被申请名称
          const respondentInfo = []
          let respondentInfoName = []
          data.respondentInfoList.forEach(item => {
            respondentInfo.push(item.departId)
            respondentInfoName.push(item.respondentName)
          })
          if (respondentInfoName.length === 0) respondentInfoName = respondentInfoName[0]
          if (respondentInfoName.length > 0) respondentInfoName = `${respondentInfoName} + ${respondentInfoName.length}`

          if (data.applicantInfoList.length) {
            data.applicantInfoList.map(item => {
              item.genderName = item.gender == '1' ? '男' : '女'
              item.birthday = item.birthday
              item.country = item.country || '1000001'
              item.countryName = item.countryName || '中国'
              item.deliveryArea = item.deliveryArea ? item.deliveryArea.split('-') : []
              if (item.applicantCategory == '2') {
                item.identificationCard = item.contactIdentificationCard
              }
              console.log(item.deliveryArea)
              item.fileListJpg = []
              item.fileListJpg2 = []
              item.fileListJpgfR = []
              const evidenceVoList = item.evidenceVoList || []
              evidenceVoList.forEach(img => {
                if (img.kindType == '3') {
                  item.fileListJpg.push({
                    evidenceName: img.evidenceName,
                    evidenceAllPath: img.evidenceAllPath,
                    showPath: img.showPath || img.evidenceAllPath,
                    evidenceType: img.evidenceType,
                    id: img.id,
                    name: img.evidenceName,
                    url: img.showPath.includes('https://landing.iflysec.com:443') ? img.showPath.replace('https://landing.iflysec.com:443', 'http://172.31.243.74:88') : img.showPath,
                    showType: img.showType,
                    kindType: 3,
                    isHistory: true
                  })
                } else if (img.kindType == '0') {
                  item.fileListJpgfR.push({
                    evidenceName: img.evidenceName,
                    evidenceAllPath: img.evidenceAllPath,
                    showPath: img.showPath || img.evidenceAllPath,
                    evidenceType: img.evidenceType,
                    id: img.id,
                    name: img.evidenceName,
                    url: img.showPath.includes('https://landing.iflysec.com:443') ? img.showPath.replace('https://landing.iflysec.com:443', 'http://172.31.243.74:88') : img.showPath,

                    showType: img.showType,
                    kindType: 0,
                    isHistory: true
                  })
                } else {
                  item.fileListJpg2.push({
                    evidenceName: img.evidenceName,
                    evidenceAllPath: img.evidenceAllPath,
                    showPath: img.showPath || img.evidenceAllPath,
                    name: img.evidenceName,
                    evidenceType: img.evidenceType,
                    id: img.id,
                    url: img.showPath.includes('https://landing.iflysec.com:443') ? img.showPath.replace('https://landing.iflysec.com:443', 'http://172.31.243.74:88') : img.showPath,

                    showType: img.showType,
                    kindType: 4,
                    isHistory: true
                  })
                }
              })
            })
          }

          data.respondentInfoList.forEach(item => {
            item.name = item.respondentName
          })

          const agency = {
            id: data.caseApplyDetail.reconsiderationAgency,
            name: data.caseApplyDetail.reconsiderationAgencyName
          }
          const caseInfo = data.caseInfo || {}
          const caseStatus = data.wssqCaseStatus
          const wssqCaseStatusName = data.wssqCaseStatusName
          const caseNo = data.caseNo
          console.log(data.caseNo)
          const caseTips = data.caseInfo.caseTips || ''

          const hasSlsc = data.hasSlsc || ''
          let modifyStatus = 0
          if (caseTips.includes('ajibzz')) {
            modifyStatus = 1
          }
          if (caseTips.includes('ajbz')) {
            modifyStatus = 2
          }
          this.caseInfo = caseInfo
          this.caseInfoDetail = data
          this.hasSlsc = hasSlsc
          this.wssqCaseStatusName = wssqCaseStatusName
          this.modifyStatus = modifyStatus
          this.caseStatus = caseStatus
          this.caseNo = caseNo
          console.log(this.caseNo)
          this.agency = agency
          this.applicantInfoList = data.applicantInfoList || []
          this.applyInfo = data.caseApplyDetail
          this.applyInfo.actCategory = data.caseApplyDetail.actCategory + '' || '1'
          this.applyInfo.specificActType = data.caseApplyDetail.specificActType + '' || ''
          this.applyInfo.actDocumentNo = data.caseApplyDetail.actDocumentNo + '' || ''
          this.applyInfo.actDecisionDate = data.caseApplyDetail.actDecisionDate + '' || ''
          this.applyInfo.actName = data.caseApplyDetail.actName + '' || ''
          this.applyInfo.applyType = data.caseApplyDetail.applyType || ''
          this.factAndReason = data.caseApplyDetail.factsAndReasons || ''
          this.respondentList = data.respondentInfoList
          this.respondentInfoName = respondentInfoName
          this.fileList1 = specFileList
          this.historyList = historyList
          this.isAgreeMediate = data.caseApplyDetail.isAgreeMediate || null
          this.detailInfo = data;
        }
      })
    },
    // 增加一个申请人
    addApplicantInfo (type) {
      // 增加一个 个人
      if (type === '1') {
        this.applicantInfo.fileListJpg = []
        const applicantInfo = { ...this.applicantInfo, id: uuid() }
        this.$nextTick(() => {
          this.$refs.refApplicant.addItem(applicantInfo)
        })
      } else {
        // 增加一个法人
        this.legalpersonInfo.fileListJpg = []
        this.legalpersonInfo.fileListJpg2 = []
        const legalpersonInfo = { ...this.legalpersonInfo, id: uuid() }
        this.$nextTick(() => {
          this.$refs.refApplicant.addItem(legalpersonInfo)
        })
      }
    },
    // 文件上传
    // 上传文件之前的钩子
    beforeUpload (file) {
      const isLt20MB = file.size / 1024 / 1024 < 20
      let fileAllSize = 0 // 总共大小
      this.fileList1.forEach(item => {
        fileAllSize += item.size
      })
      const isLt50Mb = fileAllSize / 1024 / 1024 < 50
      const a = file.name
      const b = [
        '.txt',
        '.doc',
        '.docx',
        '.xls',
        '.xlsx',
        '.pdf',
        '.jpg',
        '.gif',
        '.png',
        '.bmp',
        '.wav',
        '.rar',
        '.wps',
        '.jpeg'
      ]
      const isType = b.includes(a.slice(a.lastIndexOf('.')).toLowerCase())
      if (!isLt20MB) {
        if (document.getElementsByClassName('el-message').length > 0) {
          return false
        }
        this.$toast({
          message: '上传文件大小不能超过 20MB!',
          type: 'warning',
          center: true
        })
        return false
      }

      if (!isLt50Mb) {
        if (document.getElementsByClassName('el-message').length > 0) {
          return false
        }
        this.$toast({
          message: '总大小不能超过50MB',
          type: 'warning',
          center: true
        })
        return false
      }

      if (!isType) {
        if (document.getElementsByClassName('el-message').length > 0) {
          return false
        }
        this.$toast({
          message:
            '上传文件格式必须为1.txt 2.doc 3.docx 4.xls 5.xlsx 6.pdf 7.jpg 8.gif 9.png 10.bmp 11.wav 12.rar 13.wps 14.jpeg',
          type: 'warning',
          center: true
        })
        return false
      }
    },
    // 限制文件上传个数
    handleExceed (files, fileList) {
      const remain = MAX_UPLOAD_COUNT - this.uploadedCount1
      const tail = remain > 0 ? `本次还可上传 ${remain} 个` : '已达上限'
      this.$toast(`当前限制选择 ${MAX_UPLOAD_COUNT} 个文件，${tail}，请删除部分文件后重新上传`)
    },
    // 自定义上传
    handleUpload (param) {
      const formData = new FormData()
      formData.append('caseOrderNo', this.caseOrderNo)
      formData.append('evidenceName', param.file.name)
      formData.append('file', param.file)
      formData.append('kindType', param.data.kindType) // 证据材料类型（0证件照1具体行政行为材料2其他补充材料）
      Api.appletsUpload(formData)
        .then(({ data }) => {
          if (data.code === 'forbid' || data.code !== '0') {
            this.$toast(data.msg || '上传失败')
            return
          }
          const fileList1 = this.fileList1
          const resData = data.data

          fileList1.push({
            ...resData,
            url: resData.showPath,
            name: param.file.name,
            thumb: resData.showPath,
            type: param.file.type,
            sourceType: this.opera == 0 ? 1 : 5
          })
          this.fileList1 = fileList1
        })
        .catch((error) => {
          const errorMsg = error.response?.data?.msg || error.message || '上传失败，请重试'
          this.$toast(errorMsg)
        })
    },
    beforeRemove (file) {
      const specFileList = this.fileList1 // 这里是前端页面展示的数组
      const item = specFileList.find(item => item.id === file.id)
      if (item && item.isHistory) {
        this.$toast({
          message: '不可以删除历史文件',
          duration: 4000
        })
        return false
      }
    },
    // 删除文件
    handleRemove (file) {
      let specFileList = this.fileList1 // 这里是前端页面展示的数组
      specFileList = specFileList.filter(item => {
        return !(item.id === file.id)
      }) // 删除1张刚刚点击的那图
      this.fileList1 = specFileList
    },
    // 必填校验
    sureVale () {
      if (this.checked()) {
        return Promise.reject()
      }
      return new Promise((resolve, reject) => {
        if (this.applicantInfoList.length === 0) {
          this.$toast('至少添加一个申请人信息')
          return
        }

        if (!this.agency && this.agency.id) {
          this.$toast('请选择复议机关')
          return
        }

        if (!this.applyInfo.applyType) {
          this.$toast('请输入行政复议请求')
          return
        }
        if (!this.factAndReason) {
          this.$toast('请输入事实和理由')
          return
        }
        if (this.opera != 1) {
          if (this.fileList1.length === 0) {
            this.$toast('请上传具体行政行为证明材料')
            return
          }
        }
        if (
          this.applicantInfoList.length !== 0 &&
          this.respondentList.length !== 0 &&
          this.applyInfo.applyType &&
          this.factAndReason
        ) {
          resolve()
        }
      })
    },
    async compUsers () {
      // 校验所有申请人人口库
      const applicantInfoListCal = []
      if (this.applicantInfoList && this.applicantInfoList.length) {
        this.applicantInfoList.forEach((item) => {
          if (item.identificationType === '1001001') {
            if (item.applicantCategory === '1') {
              applicantInfoListCal.push({
                name: item.applicantName,
                id: item.identificationCard
              })
            } else if (item.applicantCategory === '2') {
              applicantInfoListCal.push({
                name: item.legalRepresentative,
                id: item.identificationCard
              })
            }
          }
        })
        const param = [...applicantInfoListCal]
        console.log(param, '437')
        const res = await this.checkUsers(param)
        return res
      }
    },
    async checkUsers (param) {
      if (!param || param.length <= 0) {
        return
      }
      let res = await Api.checkUsers(param)
      res = res?.data?.data
      console.log(res, '448')
      if (!res.code && res.result.length) {
        console.log('450')
        const str = res.result.join('、')
        return str
      } else {
        return ''
      }
    },
    isSupermarket (substring) {
      if (!substring) return true
      if (substring.indexOf('家乐福') !== -1 || substring.indexOf('苏宁易购') !== -1 || substring.indexOf('上海联家') !== -1 || substring.indexOf('联华集团') !== -1) {
        return false
      }
      return true
    },
    isBlock (substring) {
      if (!substring) return true
      if (substring.indexOf('爱家') !== -1 && substring.indexOf('月子中心') !== -1) {
        return false
      }
      return true
    },
    // 提交申请
    async submit () {
      if (isEmojiCharacter(this.factAndReason) || isEmojiCharacter(this.applyInfo.actName) || isEmojiCharacter(this.applyInfo.actDocumentNo) || isEmojiCharacter(this.applyInfo.applyType)) {
        return this.$toast('文字含有表情符号，请去掉文字内嵌入的图片')
      }
      if (this.respondentInfoName === '上海市人民政府') {
        if (!(this.isSupermarket(this.factAndReason) && this.isSupermarket(this.applyInfo.applyType))) {
          return this.$toast('你未提供行政行为存在且系由被申请人作出的证明材料，且实质争议应通过民事途径解决')
        }
      }
      if (!(this.isBlock(this.factAndReason) && this.isBlock(this.applyInfo.applyType))) {
        return this.$toast('行政机关对民事争议的调解不属于行政复议范围')
      }
      if (!this.fileList1.length) {
        return this.$toast('请上传具体行政行为证明材料')
      }
      let message = '是否确认提交以上信息?'
      if (this.opera == 0) {
        let idPath = ''
        this.fileList1.forEach((item, index) => {
          if (item.id) {
            if (index > 0) {
              idPath += ','
            }
            idPath += item.id
          }
        })
        console.log('文件id3333', idPath, this.fileList1)
        const res = await Api.checkApplyRule({
          evidenceId: idPath
        })
        if (res.data && res.data.data && res.data.data.flag) {
          message = res.data.data.msg
        }
      }
      Dialog.confirm({
        title: '提示',
        message: message,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        customClass: 'submitMessBox'
      }).then(async () => {
        this.$refs.refApplicant.checkAll().then(() => {
          this.sureVale().then(() => {
            this.loading1 = this.$loading({
              lock: true,
              text: '正在处理',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            // 调取预览书生成预览书submit
            if (this.opera != '2') {
              if (this.opera == 1) {
                if (this.applicantInfoList.length > 1) {
                  return this.$toast('涉及多申请人的案件，请线下提交补正，如有疑问请于复议机构联系')
                }
              }

              // 申请的情况下检验一个月10次
              if (this.opera == 0) {
                if (this.applicantCategory == 1) {
                  const currentApplientInfo = localStorage.getItem('applicantInfo') ? JSON.parse(localStorage.getItem('applicantInfo')) : {}
                  // 个人申请
                  this.loading1 = this.$loading({
                    lock: true,
                    text: '正在处理',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                  })
                  Api.applyCheck({
                    applicantCategory: this.applicantCategory,
                    phone: currentApplientInfo.phone,
                    id: currentApplientInfo.identificationCard,
                    name: currentApplientInfo.loginName
                  }).then(({ data }) => {
                    this.loading1.close()
                    console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>10ci', data.code)
                    if (data.code == 0) {
                      if (data.data == 1) {
                        Dialog.confirm({
                          message: data.msg,
                          title: '提示',
                          confirmButtonText: '是',
                          cancelButtonText: '否',
                          customClass: 'submitMessBox',
                          type: 'warning'
                        }).then(async () => {
                          const params = this.getSubmitData()
                          this.loading1 = this.$loading({
                            lock: true,
                            text: '正在处理',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                          })
                          Api.reconsiderApplyExportWord({
                            ...params,
                            // sign: 1
                          }).then(({ data }) => {
                            this.loading1.close()
                            this.fileReviewDialog = true
                            this.writList = data.data.showImgPathList
                          })
                        })
                      } else {
                        // 不是补充 是申请补正 调取生成申请书
                        const params = this.getSubmitData()
                        this.loading1 = this.$loading({
                          lock: true,
                          text: '正在处理',
                          spinner: 'el-icon-loading',
                          background: 'rgba(0, 0, 0, 0.7)'
                        })
                        Api.reconsiderApplyExportWord({
                          ...params,
                          // sign: 1
                        }).then(({ data }) => {
                          this.loading1.close()
                          this.fileReviewDialog = true
                          this.writList = data.data.showImgPathList
                        })
                      }
                    }
                  })
                } else {
                  // 不是补充 是申请补正 调取生成申请书
                  const params = this.getSubmitData()
                  this.loading1 = this.$loading({
                    lock: true,
                    text: '正在处理',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                  })
                  Api.reconsiderApplyExportWord({
                    ...params,
                    // sign: 1
                  }).then(({ data }) => {
                    this.loading1.close()
                    this.fileReviewDialog = true
                    this.writList = data.data.showImgPathList
                  })
                }
              } else {
                // 不是补充 是申请补正 调取生成申请书
                const params = this.getSubmitData()
                this.loading1 = this.$loading({
                  lock: true,
                  text: '正在处理',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                })
                Api.reconsiderApplyExportWord({
                  ...params,
                  correction: 1,
                  // sign: 1
                }).then(({ data }) => {
                  this.loading1.close()
                  this.fileReviewDialog = true
                  this.writList = data.data.showImgPathList
                })
              }
            } else {
              this.endSubmit()
            }
          })
            .catch((err) => {
              return false
            })
        })
      })
      // this.$confirm('是否确认提交以上信息?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   customClass: 'submitMessBox',
      //   type: 'warning'
      // }).then(async () => {
      //   // const res = await this.compUsers()
      //   // if (res) {
      //   //   this.$toast(res)
      //   //   return false
      //   // }

      // }).catch(() => {
      // });
    },

    // 整理提交参数
    getSubmitData () {
      this.applicantInfoList.forEach(item => {
        if (item.applicantCategory == '2') {
          item.contactIdentificationCard = item.identificationCard
        }
        item.deliveryArea = item.deliveryArea.toString().replace(/,/g, '-')
        const arr = []
        if (item.fileListJpg && item.fileListJpg.length) {
          arr.push(item.fileListJpg[0].id)
        }

        if (item.fileListJpgfR && item.fileListJpgfR.length) {
          arr.push(item.fileListJpgfR[0].id)
        }

        if (item.fileListJpg2 && item.fileListJpg2.length) {
          arr.push(item.fileListJpg2[0].id)
        }
        item.wssqEvidenceId = arr.toString()
      })

      // 被申请人处理
      const respondentInfoList = []
      this.respondentList.forEach(item => {
        respondentInfoList.push({
          caseOrderNo: this.caseOrderNo,
          departId: item.departId,
          respondentName: item.name,
          electronicDelivery: 0
        })
      })
      const {
        factAndReason,
        agency,
        isAgreeMediate
      } = this
      const caseApplyDetail = {
        ...this.applyInfo,
        factsAndReasons: factAndReason,
        reconsiderationAgency: agency.id,
        reconsiderationAgencyName: agency.name
      }
      const caseInfo = {
        caseOrderNo: this.caseOrderNo,
        caseSource: 5,
        caseType: '1009001',
        applyType: '1008005',
        applicantName: this.applicantInfoList[0].applicantName,
        slaveCaseNum: '',
        relateCaseNo: '',
        isFiling: 0,
        applyReson: '',
        applicantNum: this.applicantInfoList.length,
        isAgreeMediate: isAgreeMediate * 1,
        ...this.caseInfo
      }
      const evidences = [...this.fileList1]
      const shortName = agency.shortName ? agency.shortName : ''
      let caseNo = {}
      if (this.isDetail) {
        caseNo = this.caseNo
      } else {
        // 根据复议机关名称判断案号类型：上海市司法局用"司复字"，其他用"府复字"
        const caseType = (agency.name && agency.name.includes('上海市司法局')) ? '司复字' : '府复字'
        caseNo = {
          city: shortName,
          year: new Date().getFullYear(),
          type: caseType
        }
      }
      const params = {
        respondentInfoList,
        applicantInfoList: this.applicantInfoList,
        caseApplyDetail,
        caseInfo,
        evidenceList: evidences,
        caseNo
      }
      return params
    },
    closeFileReviewDialog () {
      this.fileReviewDialog = false;
      this.isSign = false; // 返回后要重新签名
      console.log(this.isSign, 'isSign');

    },
    // 显示确认弹窗
    showConfirmDialog() {
      if (this.isSign === true) {
        this.endSubmit()
      } else {
        this.doSubmit();
      }
    },

    // 最后提交
    doSubmit () {
      Dialog.confirm({
        message: '是否确认行政复议申请书无误',
        title: '提示',
        confirmButtonText: '签名',
        cancelButtonText: '取消',
        customClass: 'submitMessBox',
        type: 'warning'
      }).then(() => {
        // this.endSubmit()
        this.$refs.mobileSignDialog.open();
      })
    },
    endSubmit () {
      this.fullscreenLoading = true // 提交加载
      const params = this.getSubmitData()
      let {
        evidenceList
      } = params
      if (this.isDetail) {
        const that = this
        const {
          opera
        } = this
        evidenceList = evidenceList.filter(item => !item.isHistory)
        // 补充
        if (this.opera == '2') {
          this.loading2 = this.$loading({
            lock: true,
            text: '正在处理',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          Api.replenish({
            evidenceList
          }).then(({ data }) => {
            this.loading2.close();
            if (data.code == "0") {
              this.fullscreenLoading = false
              Dialog.alert({
                message: '补充成功',
                title: '提示',
                confirmButtonText: '确定',
                customClass: 'submitMessBox',
                callback: action => {
                  this.$router.replace({
                    name: 'MDetailCase',
                    query: {
                      from: 'list',
                      number: this.caseOrderNo
                    }
                  })
                }
              })
            }
          })
          // 补正
        } else {
          console.log('补正')
          // 补正操作
          this.loading2 = this.$loading({
            lock: true,
            text: '正在处理',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          Api.saveOrUpdateCaseInfo({
            correction: 1,
            ...params
          }).then(({ data }) => {
            this.loading2.close();
            if (data.code === "0") {
              this.fullscreenLoading = false
              Dialog.alert({
                message: '补正成功',
                title: '提示',
                confirmButtonText: '确定',
                customClass: 'submitMessBox',
                callback: action => {
                  this.fileReviewDialog = false
                  this.$router.replace({
                    name: 'MDetailCase',
                    query: {
                      number: this.caseOrderNo
                    }
                  })
                }
              })
            } else {
              this.fileReviewDialog = false
              this.getCaseInfoDetail()
              this.$router.back()
            }
          })
        }
      } else {
        this.loading2 = this.$loading({
          lock: true,
          text: '正在处理',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        Api.saveOrUpdateCaseInfo({
          inquireState: localStorage.getItem('state') || '',
          ...params
        }).then(({ data }) => {
          this.loading2.close()
          if (data.code === '0') {
            this.fileReviewDialog = false
            this.fullscreenLoading = false // 提交加载
            this.number = data.data
            Dialog.alert({
              message: '提交成功',
              title: '提示',
              confirmButtonText: '确定',
              customClass: 'submitMessBox',
              callback: action => {
                this.$router.replace({
                  name: 'MDetailCase',
                  query: {
                    searchType: 1,
                    number: this.caseOrderNo
                  }
                })
              }
            })
          } else {
            if (data.msg && !['系统异常', '后台服务异常'].includes(data.msg)) {
              this.$toast(data.msg)
            } else {
              console.error('提交失败:', data.msg)
            }
            this.fileReviewDialog = false
            this.getCaseInfoDetail()
          }
        })
      }
    },

    // 返回
    back () {
      console.log(this.$route.query.name)
      if (this.$route.query.name == 'caseList') {
        this.$router.back()
      } else {
        this.$router.push('/m-selectType')
      }
    }
  }
}
